import * as Yup from "yup";

export const passwordValidation = {
  enableReinitialize: true,
  initialValues: {
    password: "",
    password_confirmation: "",
  },
  validationSchema: Yup.object({
    password: Yup.string().required("Requiredo").min(6, "Mínimo 6 caracteres"),
    password_confirmation: Yup.string()
      .required("Requiredo")
      .oneOf([Yup.ref("password"), null], "Las contraseñas deben coincidir"),
  }),
};
